import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ReactDOM from "react-dom";
import ContactForm from "../ContactMe/ContactForm";
import AnchorLink from "../components/AnchorLinkComponent";


class ProjectRescueService extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Project Rescue Services</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>There are many reasons that a project can find itself in distress. It can be as obvious as having the wrong managers or technical personnel involved. It can also be that the project was poorly designed or the original expectations were too high. Often though it is a combination of factors that have cause a project to miss deadlines and go over budget.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have rescued numerous projects during my career; both as a technical rescuer and/or as a replacement project manager.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>If you have a project which you are concerned about, please feel free to <AnchorLink value="contact me" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/contact'/> to discuss whether you really do have a problem and whether I can help you fix it.</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectRescueService



// WEBPACK FOOTER //
// src/Services/ProjectRescueServices.js